var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_668_108590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7465 12.051L9.17197 2.39555C8.86199 1.85866 8.30679 1.53809 7.68678 1.53809C7.06679 1.53809 6.51156 1.85866 6.20158 2.39555L0.627035 12.051C0.31703 12.5879 0.31703 13.229 0.627035 13.7659C0.937041 14.3028 1.49222 14.6234 2.11223 14.6234H13.2613C13.8813 14.6234 14.4365 14.3028 14.7465 13.7659C15.0565 13.229 15.0565 12.5879 14.7465 12.051ZM14.0066 13.3387C13.851 13.6081 13.5724 13.769 13.2613 13.769H2.11223C1.80111 13.769 1.52253 13.6081 1.367 13.3387C1.21147 13.0693 1.21147 12.7477 1.367 12.4782L6.9416 2.8228C7.09713 2.55339 7.37572 2.39256 7.6868 2.39256C7.99786 2.39256 8.27648 2.55339 8.43201 2.8228L14.0066 12.4782C14.1621 12.7477 14.1621 13.0693 14.0066 13.3387Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11226 5.80273H7.25781V10.075H8.11226V5.80273Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68684 10.9297C7.37273 10.9297 7.11719 11.1852 7.11719 11.4993C7.11719 11.8134 7.37273 12.069 7.68684 12.069C8.00092 12.069 8.25649 11.8134 8.25649 11.4993C8.25649 11.1852 8.00094 10.9297 7.68684 10.9297Z",
    fill: "#F93939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_668_108590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5845,
    height: 14.5845,
    fill: "white",
    transform: "translate(0.394531 0.789062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.369a64e1076c6ceb2fae3943da7a4d47.svg";
export { ForwardRef as ReactComponent };